import React from 'react'
import Sidebar from "../components/Sidebar"
import profile from '../assets/profile-image.webp'



const Team = () => {
    return (
<>
 <Sidebar/>
    <div className='Team'>
       <h1>Team</h1>

        
    </div>
        
 </>
    )
}

export default Team